// social-url-or-handle.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { urlValidator } from './url-validator'; // your existing one
import { SocialPlatform } from './clean-social-handle.util';

export function socialUrlOrHandleValidator(_platform?: SocialPlatform): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: string = (control.value || '').trim();
    if (!value) return null; // optional

    const looksLikeUrl = value.includes('.') || value.startsWith('http') || value.startsWith('www.');

    if (looksLikeUrl) {
      // Reuse your existing URL validator
      return urlValidator(control);
    }

    // Treat as handle — simple pattern: @, letters, digits, dot, underscore, dash
    const handlePattern = /^@?[A-Za-z0-9._-]+$/;

    return handlePattern.test(value) ? null : { invalidHandle: true };
  };
}
